/**
 * @todo Удалить директорию полностью
 * @description Данный функционал появился в задаче CD-194493, будет удалён в задаче CD-194545
 */

import * as React from 'react';
import { useSelector } from 'react-redux';
import { NativeTGBNormalDescription } from '../../components/NativeTGB';
import { getCurrentJsonQuery } from '../../selectors/location';
import { ISimplifieldTGBBannerContext } from '../../types/adfox';

export interface INewResidentialNativeTGBBannerProps {
  context: ISimplifieldTGBBannerContext;
}

export function NativeTGBannerContainer({ context }: INewResidentialNativeTGBBannerProps) {
  const jsonQuery = useSelector(getCurrentJsonQuery);
  const locationId = React.useMemo(() => (jsonQuery.region ? jsonQuery.region.value[0] : undefined), [jsonQuery]);

  return <NativeTGBNormalDescription context={context} locationId={locationId} />;
}
